type WindowSize = {
    width: number;
    height: number;
};

// Horizontal scroll offset (in px) for the project carousel at a given slide index.
// Shared between the click-to-scroll buttons and drag/touch scrolling so both stay in sync.
export const getCarouselOffset = (index: number, windowSize: WindowSize): number => {
    if (index <= 0) return 0;
    return (
        (windowSize.width * 60) / 100 +
        (windowSize.width * ((index + 1) * 0.8)) / 100 +
        (windowSize.height * ((index - 1) * 63)) / 100 -
        ((windowSize.width * 88) / 100 - (windowSize.height * 63) / 100)
    );
};
